import { StorageKey } from '../../web-store-api/enums';
import { isLoggedIn } from './is-logged-in';

export const getCurrentCustomerId = async () => {
  return (await isLoggedIn())
    ? localStorage.getItem(StorageKey.CustomerAuthId)
    : localStorage.getItem(StorageKey.CustomerGuestId);
};
